import HorizontalSelect from './HorizontalSelect';

export default HorizontalSelect;
